import { RoutePaths } from "@/config/route-paths";

export function getEditCredentialSheetBack({
  customerId,
  organizationId,
  sport,
}: {
  customerId: number;
  organizationId: string;
  sport: string;
}) {
  return RoutePaths.credentials.list({ customerId, organizationId, sport });
}
